// hooks/useButtonMonitor.js
import { useCallback } from 'react';
import chatConfigService from '../components/services/chatConfigService';

export const useButtonMonitor = (setMessages) => {
  
  const sendButtonUpdate = useCallback(async (eventType, data) => {
    console.log('🔄 Button Monitor:', { eventType, data });

    let apiPromise;

    // Handle all event types
    switch (eventType) {
      case 'language_changed':
        apiPromise = chatConfigService.notifyLanguageChanged(data.languageName || data.newValue);
        break;
      
      case 'llm_changed':
        apiPromise = chatConfigService.notifyLlmChanged(data.llmName || data.newValue, data.modelId);
        break;
      
      case 'model_changed':
        apiPromise = chatConfigService.notifyModelChanged(data.modelId, data.modelName);
        break;
      
      case 'query_changed':
        // Handle both queryId and queryKey
        const queryKey = data.queryId || data.queryKey || data.newValue;
        if (queryKey) {
          apiPromise = chatConfigService.notifyQueryChanged(queryKey);
        } else {
          console.warn('No query key provided for query_changed');
          return;
        }
        break;
      
      case 'custom_query_created':
        apiPromise = chatConfigService.notifyCustomQueryCreated(
          data.queryName || data.queryKey,
          data.queryText
        );
        break;
      
      case 'custom_query_edited':
        apiPromise = chatConfigService.notifyCustomQueryEdited(
          data.queryName || data.queryKey,
          data.oldText,
          data.newText
        );
        break;
      
      case 'custom_query_deleted':
        apiPromise = chatConfigService.notifyCustomQueryDeleted(
          data.queryName || data.queryKey
        );
        break;
      
      default:
        console.warn('Unknown event type:', eventType);
        return;
    }

    // Send to API only - NO MESSAGES ADDED TO CHAT
    try {
      await apiPromise;
      // Success - no message shown
      console.log('✅ Config update sent to backend');
      
    } catch (error) {
      console.error('❌ API Call failed:', error);
      
      // Only show errors for critical failures
      if (error.message.includes('Authentication') || error.message.includes('network')) {
        const errorMessage = {
          id: Date.now(),
          text: `❌ Failed to save settings: ${error.message}`,
          sender: 'system',
          systemType: 'error',
          timestamp: new Date().toISOString()
        };
        setMessages(prev => [...prev, errorMessage]);
      }
    }

  }, [setMessages]);

  return { sendButtonUpdate };
};